import { fetchAccessToken } from '@doda/common/src/logics/fetchAccessToken';
import { OrderInfoResponse } from '@doda/api-client/aspida/@types';
import { getSelectionDocumentsOrderInfoList } from '@doda/common/src/services/getSelectionDocumentsOrderInfoListAPI';
import { IncomingHttpHeaders } from 'http';

/**
 * 個人顧客提出案件書類取り寄せ情報取得
 * @param dcfrontHeaders
 * @returns selectionDocumentsOrderInfoList
 */
export const fetchSelectionDocumentsOrderInfoList = async (
  dcfrontHeaders?: IncomingHttpHeaders
): Promise<OrderInfoResponse[]> => {
  const accessToken = await fetchAccessToken(dcfrontHeaders);
  if (!accessToken) return [];

  try {
    return await getSelectionDocumentsOrderInfoList(accessToken);
  } catch (error) {
    return [];
  }
};
